import React, { Component } from 'react'
import Card, { CardContent, CardActions } from 'material-ui/Card'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'

class AddPriceCard extends Component {
  constructor (props) {
    super(props)
    this.state = {price: undefined}
  }

  render () {
    return (
      <Card className='card'>
        <CardContent>
          <div>
            <TextField
              label='Enter Price'
              type='number'
              onChange={(event) => { this.setState({price: event.target.value}) }}
              fullWidth
            /><br />
          </div>
        </CardContent>
        <CardActions>
          <Button
            variant='raised'
            color='primary'
            disabled={!this.state.price || this.state.price === ''}
            onClick={() => {
              this.props.onAddPrice(new Date().toISOString(), this.state.price)
              // reset the field
              this.setState({price: undefined})
            }}>
          Add Price
          </Button>
        </CardActions>
      </Card>
    )
  }
}

export default AddPriceCard



// WEBPACK FOOTER //
// ./src/products/AddPriceCard.js